
<div class="incadea-container">
  <span *ngIf="token$ | async"></span>
  <div class="col-lg-12" align="center" class="dialog-title">
    <h1>{{"UpdateSchedule" | translate}}</h1>
  </div>
  <div class="col-lg-12" align="center">
    <h2 class="dialog__section-title">
      {{"OwnerData" | translate}}
      <i class="bi bi-pencil-fill edit" (click)="toggleButtons()"></i>
    </h2>

    <mat-button-toggle-group class="dialog__toggle-group" *ngIf="isEditable">
      <mat-button-toggle class="EditOwnerStyleButton" (click)="editOwner()">
        {{"EditOwner" | translate}}
      </mat-button-toggle>
      <mat-button-toggle class="UpdateOwnerStyleButton" (click)="newOwner()">
        {{"UpdateOwner" | translate}}
      </mat-button-toggle>
    </mat-button-toggle-group>
  </div>

 
  <section class="loading-container-finalize" *ngIf="!isLoadingSave">
    <div  class="pulsing" >
      <mat-spinner [diameter]="50" ></mat-spinner>
    </div>
  <p class="pulsing" >{{ "Loading" | translate }}</p>
  </section>
  <mat-dialog-content class="schedule-reschedule-dialog" [class.is-saving]="isSaving || false">

  <form
    [ngClass]="{'contenido-deshabilitado': !isLoadingSave}"
    (ngSubmit)="onSubmit()"
    class="col-lg-12"
    [formGroup]="RescheduleForm"
  > <div class="col-lg-12" *ngIf="!showEditForm; else fields">
    <h3 class="col-lg-6">
      <strong>{{"Name" | translate}}</strong> {{RescheduleForm.get('fullName')!.value}}
    </h3>
    <h3 class="col-lg-6">
      <strong>{{"Typededoc" | translate}}</strong> 
      {{RescheduleForm.get('docType')!.value.typeName}}
    </h3>
    <h3 class="col-lg-6">
      <strong>{{"NumerDocument" | translate}}</strong>
      {{RescheduleForm.get('documentNumber')!.value}}
    </h3>
    <h3 class="col-lg-6">
      <strong>{{"CustomerVehicleRelationship" | translate}}</strong>
       {{RescheduleForm.get('customerRelationshipVehicle')!.value.relationshipName | translate  }}
    </h3>
    <h3 class="col-lg-6">
      <strong>{{"Phone" | translate}}</strong
      >{{RescheduleForm.get('phone')!.value}}
    </h3>
    <h3 class="col-lg-6">
      <strong>{{"Email" | translate}}</strong> {{RescheduleForm.get('email')!.value}}
    </h3>
    <h3 class="col-lg-6">
      <strong>{{"Plate" | translate}}</strong> {{initialFormData.LicenseNo}}
    </h3>
    <h3 class="col-lg-6">
      <strong>{{"VIN" | translate}}</strong> {{initialFormData.VIN}}
    </h3>
  </div>

  
  <ng-template #fields>
    <div class="col-lg-12">
      <div class="col-lg-6">
        <mat-form-field class="nameMargin">
          <mat-label>{{"Name" | translate}}</mat-label>
          <input
            type="text"
            matInput
            formControlName="fullName"
           oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,_-]/g, '')"
            maxlength="50"
          />
        </mat-form-field>
      </div>
      <div class="col-lg-6">
        <mat-form-field class="dialog__form-field">
          <label class="dialog__label">{{ "Typededoc" | translate }}</label>
          <mat-select formControlName="docType">
            <mat-option
            *ngFor="let typeOfDocument of documentType"
            [value]="typeOfDocument"
            >{{typeOfDocument.typeName}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-lg-6">
        <mat-form-field>
          <mat-label>{{"NumerDocument" | translate}}</mat-label>
          <input
          type="text"
          matInput
          formControlName="documentNumber"
         oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,_-]/g, '')"
          maxlength="15"/>
        </mat-form-field>
      </div>
      <div class="col-lg-6">
        <mat-form-field>
          <mat-label>{{"CustomerVehicleRelationship" | translate}}</mat-label>
          <mat-select formControlName="customerRelationshipVehicle">
            <mat-option
              *ngFor="let relation of relationshipCustomerVehicle"
              [value]="relation"
            >
              {{relation.relationshipName | translate}}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="RescheduleForm.get('customerRelationshipVehicle')!.hasError('required')">
            {{"RelationshipIs" | translate}}
            <strong>{{"Required" | translate}}</strong>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-lg-6">
        <mat-form-field>
          <mat-label> {{"Phone" | translate}}</mat-label>
          <input
          type="text"
          matInput
          formControlName="phone"
          oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,]/g, '')"
          maxlength="15"/>
        </mat-form-field>
      </div>
      <div class="col-lg-6">
        <mat-form-field>
          <mat-label>{{"Email" | translate}}</mat-label>
          <input
            type="text"
            matInput
            formControlName="email"
            maxlength="50"/>
            <mat-error *ngIf="emailControl!.hasError('invalidEmail')">
              {{"EmailNotValid" | translate}}
            </mat-error>
            <mat-error *ngIf="emailControl!.hasError('required')">
              {{"EmailIs" | translate}}
              <strong>{{"Required" | translate}}</strong>
            </mat-error>
        </mat-form-field>
      </div>
      <h3 class="col-lg-6">
        <strong>{{"Plate" | translate}}</strong> {{initialFormData.LicenseNo}}
      </h3>
      <div class="col-lg-6">
        <mat-form-field>
          <mat-label>{{"VIN" | translate}}</mat-label>
          <input
            type="text"
            matInput
            formControlName="vin"
           oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,_-]/g, '')"
            maxlength="50"/>
        </mat-form-field>
      </div>
    </div>
  </ng-template>
  
  
    
      <h2 class="col-lg-12 dialog__section-title">
        {{"ReservationData" | translate}}
      </h2>
    <!-- filters -->
    <div class="col-lg-6 ">
    <mat-form-field  >
      <mat-label
        >{{ "Company" | translate  | capitalize}}
      </mat-label>
      <mat-select 
      formControlName="company" 
      (selectionChange)="getLocationsDepartmentsAndMakes()"
     
      >
        <mat-option
          *ngFor="let company of companies$ | async"
          [value]="company"
          
        >
          {{ company.Name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    </div>
    <div class="col-lg-6 ">
    <mat-form-field >
      <mat-label
        >{{ "Location" | translate  | capitalize}}
      </mat-label>
      <mat-select formControlName="location" (selectionChange)="onLocationChange()"
      >
        <mat-option
          *ngFor="let location of locations "
          [value]="location"
          (click)="clearFilters('location')"
        >
        {{ location.Description}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    </div>
    <div class="col-lg-6 ">
    <mat-form-field >
      <mat-label
        >{{ "Department" | translate  | capitalize}}
      </mat-label>
      <mat-select formControlName="department">
        <mat-option
          *ngFor="let department of departments$ | async"
          [value]="department"
          (click)="clearFilters('department')"
        >
          {{ department.Description }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    </div>
    <div class="col-lg-6 ">
    <mat-form-field >
      <mat-label
        >{{ "Make" | translate  | capitalize}}
      </mat-label>
      <mat-select formControlName="make" (selectionChange)="onMakeChange()">
        <mat-option
          *ngFor="let make of makes$ | async"
          [value]="make"
          (click)="clearFilters('make')"
        >
        {{ make.Description }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    </div>
    <div class="col-lg-6 ">
    <mat-form-field >
      <mat-label
        >{{ "Service" | translate  | capitalize}}
      </mat-label>
      <mat-select formControlName="typeOfService" >
        <mat-option
          *ngFor="let service of services$ | async"
          [value]="service"
          (click)="clearFilters('typeOfService')"
        >
          {{ service.Name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    </div>
    <div class="col-lg-6 ">
    <mat-form-field >
      <mat-label
        >{{ "Resource" | translate  | capitalize}}
      </mat-label>
      <mat-select formControlName="resource" (selectionChange)="onResourceChange()">
        <mat-option
          *ngFor="let resource of resources$ | async"
          [value]="resource"
        >
        {{ resource.Description }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    </div>

      <div class="col-lg-6"> 
      <mat-form-field>
        <mat-label>{{"Mileage" | translate}}</mat-label>
        <input
          type="text"
          matInput
          formControlName="mileAge"
          oninput="value = value.replace(/[^0-9 ]/g, '')"
          maxlength="6"
          />
      </mat-form-field>
      </div>
      <h3 class="col-lg-6"><strong>{{"Channel" | translate}}</strong> {{initialFormData.DataPrivacyConsent[0].CommunicationChannels}}</h3>
      <div class="col-lg-12">
      <div class="col-lg-6 ">
        
        <mat-form-field class="dialog__form-field dialog__form-field-fecha">
          <mat-label >{{"Date" | translate}}</mat-label>
          <input
            matInput 
            [matDatepicker]="picker" 
            [matDatepickerFilter]="dateFilter" 
            [min]="currentDate"
            formControlName="date" 
          (dateChange)="setHoursOptions($event)"
            >
          <mat-datepicker-toggle matSuffix [for]="picker" #toggleButton="matDatepickerToggle"></mat-datepicker-toggle>
          <mat-datepicker #picker >
          </mat-datepicker>
          <mat-error >
            {{"DateIs" | translate}} <strong>{{"Required" | translate}}</strong>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-lg-6">
        <mat-form-field>
          <mat-label>{{"Time" | translate}}</mat-label>
          <mat-select formControlName="time" >
            <mat-option
              *ngFor="let time of availableHours "
              [value]="time"
            >
            {{ time | date: "hh:mm a"  }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

      <div class="col-lg-12">
        <!-- <mat-form-field appearance="outline">
          <mat-label>{{"Observations" | translate}}</mat-label>
          <textarea matInput placeholder="Ex. It makes me feel..."  formControlName="comments"></textarea>
        </mat-form-field>-->
        <mat-form-field> 
          <mat-label>{{"Observations" | translate}}</mat-label>
          <input
            type="text"
            matInput
            formControlName="comments"
           oninput="value = value.replace(/[^a-zA-Z0-9 ñáéíóúÁÉÍÓÚ$()#\-_.¿?%]/g, '')"
            maxlength="100"
            (input)="charCount = RescheduleForm.get('comments')?.value?.length || 0"
          />
          <mat-hint align="start">{{ charCount }}/100</mat-hint>
        </mat-form-field>
      </div>
      <div class="col-lg-6">
        <p>{{"OwnerWillBeOnSite" | translate}}</p>
      </div>

      <div class="col-lg-6">
        <mat-radio-group
          aria-label="Select an option"
          class="dialog__radio-group"
          formControlName="ownerShowUp"
        >
          <mat-radio-button
            [value]=true
        
            labelPosition="before"
            class="dialog__radio-button"
            >{{"Yes" | translate}}</mat-radio-button
          >
          <mat-radio-button
            [value]=false
        
            labelPosition="before"
            class="dialog__radio-button"
            >{{"No" | translate}}</mat-radio-button
          >
        </mat-radio-group>
      </div>
    </form>
    <form
    class="row col-lg-12"
    [formGroup]="ReprensentativeForm"
    [ngClass]="{'contenido-deshabilitado': !isLoadingSave}"
    *ngIf="RescheduleForm.get('ownerShowUp')!.value===false"
    >
    <h2 class="col-lg-12 dialog__section-title">
      {{"RepresentativeInformation" | translate}}
    </h2>

    <div class="col-lg-6 "> 
      <mat-form-field class="nameMargin">
        <mat-label>{{"Name" | translate}}</mat-label>
        <input
          type="text"
          matInput
          formControlName="fullName"
         oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,_-]/g, '')"
          maxlength="50"
        />
      
      </mat-form-field>
    </div>

    <div class="col-lg-6">
      <mat-form-field class="dialog__form-field">
        <label class="dialog__label">{{ "Typededoc" | translate }}</label>
        <mat-select formControlName="docType">
          <mat-option
          *ngFor="let typeOfDocument of documentType"
          [value]="typeOfDocument"
          >{{typeOfDocument.typeName}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="col-lg-6 ">
      <mat-form-field>
        <mat-label>{{"NumerDocument" | translate}}</mat-label>
        <input
          type="text"
          matInput
          formControlName="documentNumber"
          oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,]/g, '')"
          maxlength="15"
        />
      
      </mat-form-field>
    </div>
    <div class="col-lg-6">
      <mat-form-field>
        <mat-label>{{"Phone" | translate}}</mat-label>
        <input
          type="text"
          matInput
          formControlName="phone"
          oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,]/g, '')"
          maxlength="15"
        />
      </mat-form-field>
    </div>
    <div class="col-lg-6 ">
      <mat-form-field>
        <mat-label>{{"Email" | translate}}</mat-label>
        <input
          type="text"
          matInput
          formControlName="email"
          maxlength="50"
        />

      </mat-form-field>
    </div>

  </form>

  <form
  [ngClass]="{'contenido-deshabilitado': !isLoadingSave}"
    [formGroup]="termsAndConditions"
    class="row col-lg-12"
  >
    <div class="col-lg-8">
      <p>
        {{"DeclareToKnowAndUnderstand"| translate}}
        <span class="highlight"
          >{{"PersonalDataProtectionPolicy" | translate}}</span
        >
        {{"AndAuthorize" | translate}}
      </p>
      <mat-error *ngIf="policiesControl!.invalid">
        {{"MustAgreeToDataProtectionPolicy" | translate}}
      </mat-error>
    </div>
    <div class="col-lg-4">
      <mat-radio-group class="dialog__radio-group" formControlName="acceptProtectionPolicy">
        <mat-radio-button
          [value]=true
          labelPosition="before"
          class="dialog__radio-button"
          >{{"Yes" | translate}}</mat-radio-button
        >
        <mat-radio-button
          [value]=false
          labelPosition="before"
          class="dialog__radio-button"
          >{{"No" | translate}}</mat-radio-button
        >
      </mat-radio-group>

    
    </div>

    <div class="col-lg-8">
      <p>
        {{"IAgree" | translate}}
        <span
          ><a class="highlight">{{"TermsAndConditions" | translate}}</a></span
        >
      </p>
      <mat-error  *ngIf="termsControl!.invalid" >
      {{"MustAgreeToTermsAndConditions" | translate}}
    </mat-error>
    </div>

    <div class="col-lg-4">
      <mat-radio-group
        aria-label="Select an option"
        class="dialog__radio-group"
        formControlName="acceptTermsAndConditions"
      >
        <mat-radio-button
         [value]=true
          labelPosition="before"
          class="dialog__radio-button"
          >{{"Yes" | translate}}</mat-radio-button
        >
        <mat-radio-button
          [value]=false
          labelPosition="before"
          class="dialog__radio-button"
          >{{"No" | translate}}</mat-radio-button
        >
      </mat-radio-group>
    </div>


        <!-- End terminos condiciones politicas-->
        <ng-template #loading>
        
          <section class="dialog-loading-container" *ngIf="false">
            <div  class="pulsing" >
              <mat-spinner [diameter]="50" ></mat-spinner>
            </div>
            <p class="pulsing" >{{ "LoadingData" | translate }}</p>
          </section>
        </ng-template>
        
   
  </form>
</mat-dialog-content>
<div class="col-lg-12">
  <mat-dialog-actions align="center">
    <button mat-dialog-close class="dialog__button" *ngIf="!isSaving">
      {{"Cancel" | translate}}
    </button>
    <button 
    class="dialog__button" 
    type="submit" 
    *ngIf="!isSaving" 
    (click)="onSubmit()"
    [disabled]= "formsValidations()">
      {{"Accept" | translate}}
    </button>
  </mat-dialog-actions>
</div>
</div>
